export const LoadedProductData = {};
export const LoadAllProductData = () => {
    const elements = jQuery(`.common-product-fields`);
    elements.each((_, element) => {
        let data = JSON.parse(element.textContent);
        if (!data) {
            return;
        }
        if (Array.isArray(data)) {
            for (const item of data) {
                LoadedProductData[item.variant_id] = item;
            }
        }
        else {
            LoadedProductData[data.variant_id] = data;
        }
    });
};
export const GetProductData = (id) => {
    var _a, _b, _c;
    if (((_a = globalThis.common_products) === null || _a === void 0 ? void 0 : _a[id]) || LoadedProductData[id]) {
        return ((_b = globalThis.common_products) === null || _b === void 0 ? void 0 : _b[id]) || (LoadedProductData === null || LoadedProductData === void 0 ? void 0 : LoadedProductData[id]);
    }
    LoadAllProductData();
    return ((_c = globalThis.common_products) === null || _c === void 0 ? void 0 : _c[id]) || (LoadedProductData === null || LoadedProductData === void 0 ? void 0 : LoadedProductData[id]);
};
export const LoadProductData = (id, data) => {
    LoadedProductData[id] = data;
};
export const LoadProductDataItems = (data) => {
    for (const item of data) {
        LoadProductData(item.variant_id, item);
    }
};
export const GetProductDataList = () => {
    if (Object.keys(LoadedProductData).length > 0) {
        return LoadedProductData;
    }
    LoadAllProductData();
    return LoadedProductData;
};
export const GetExtraProducts = (id) => {
    const extraProductElement = jQuery(`.extra-product-items[data-product-id="${id}"]`);
    if (extraProductElement.length == 0) {
        return [];
    }
    const extraProductItems = JSON.parse(extraProductElement[0].textContent);
    return extraProductItems;
};
export const GetExtraAllProducts = () => {
    const extraProductElements = jQuery(`script.extra-product-items`);
    if (extraProductElements.length == 0) {
        return {};
    }
    return extraProductElements.toArray().reduce((result, element) => {
        var _a;
        const extraProductItems = JSON.parse((_a = element.textContent) !== null && _a !== void 0 ? _a : '[]');
        const variant_id = jQuery(element).data('product-id');
        result[variant_id] = extraProductItems !== null && extraProductItems !== void 0 ? extraProductItems : [];
        return result;
    }, {});
};
let commonSettings = null;
let accountSettings = null;
let customer = null;
export const GetJsonContent = (queryElement) => {
    const element = jQuery(queryElement);
    if (element.length) {
        return JSON.parse(element.get()[0].textContent);
    }
    return null;
};
export const GetCustomer = () => {
    if (customer) {
        return customer;
    }
    const data = GetJsonContent('#customer');
    if (data) {
        customer = data;
    }
    return data;
};
export const LoadAccountSettings = () => {
    const data = GetJsonContent('#account-settings');
    if (data) {
        accountSettings = data;
    }
    return data;
};
export const LoadCommonSettings = () => {
    const data = GetJsonContent('#common-settings');
    if (data) {
        commonSettings = data;
    }
    return data;
};
export const GetCartData = () => {
    const data = GetJsonContent('#cart-data');
    return (data !== null && data !== void 0 ? data : {});
};
const sectionData = {};
export const GetSectionData = (type) => {
    if (sectionData[type]) {
        return sectionData[type];
    }
    const element = document.querySelector(`[data-section-type="${type}"]`);
    if (element != null) {
        const data = JSON.parse(element.textContent);
        sectionData[type] = data;
        return data;
    }
    return null;
};
export const GetCommonSettings = () => {
    var _a;
    if (commonSettings) {
        return commonSettings;
    }
    return (_a = LoadCommonSettings()) !== null && _a !== void 0 ? _a : {};
};
export const GetAccountSettings = () => {
    var _a;
    if (accountSettings) {
        return accountSettings;
    }
    return (_a = LoadAccountSettings()) !== null && _a !== void 0 ? _a : {};
};
jQuery(() => {
    LoadAllProductData();
    LoadCommonSettings();
    LoadAccountSettings();
});
